import { useNavigate } from "react-router-dom";

import { ABOUT_ROUTES, PATHS } from "../../../config/routeConfig";
import { useVulnerabilityContext } from "../../../context/vulnerability/useVulnerabilityContext";
import { questionContent } from "../questions";
import MultipleChoiceQuestion from "../../../components/Questions/MultipleChoiceQuestion";
import { CustomerSupportVulnerabilityCircumstanceChildrenInput } from "../../../generated/customer/schema.graphql";

type ChildrenQuestionRecord = Record<
  keyof CustomerSupportVulnerabilityCircumstanceChildrenInput,
  string
>;

type ChildrenQuestion = Omit<
  ChildrenQuestionRecord,
  "pregnantOrChildrenUnder5" | "childrenUnder16"
> & { noneOfTheAbove: string };

export const childrenQuestions: ChildrenQuestion = {
  pregnant: "Pregnant",
  childrenUnder2: "Children under 2 years of age",
  childrenBetween2And4: "Children between 2 and 4 years of age",
  childrenBetween5And15: "Children between 5 and 15 years of age",
  noneOfTheAbove: "None of the above",
};

const Children: React.FC = () => {
  const { answers, setAnswers } = useVulnerabilityContext();

  const navigate = useNavigate();

  const onChange = (newAnswers: Record<string, boolean>) => {
    setAnswers({
      ...answers,
      children: newAnswers,
    });
  };

  const onContinue = () => {
    navigate(`/${PATHS.About}/${ABOUT_ROUTES.Sight}`);
  };

  return (
    <MultipleChoiceQuestion
      onChange={onChange}
      options={childrenQuestions}
      step={questionContent.children.step}
      title={questionContent.children.title}
      subTitle={questionContent.children.subTitle}
      whyWeWantTexts={questionContent.children.whyWeWantTextsCustomer}
      onContinue={onContinue}
      values={answers.children}
      requireAnswer
    />
  );
};

export default Children;
